import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class WordListEndpointService {
  readonly #service = inject(ServicesService);

  wordLists(arrangementCode: string) {
    return this.#service.vesta(`arrangement/${arrangementCode}/wordlists`);
  }

  wordList(arrangementCode: string, id: string, contentIdentifier: string) {
    return this.#service.vesta(
      `arrangement/${arrangementCode}/wordlists/${id}?contentIdentifier=${contentIdentifier}`,
    );
  }
}
